import React from 'react';
import { InlineWidget } from "react-calendly";

export const Calendar = (props) => {
    return (
        <div style={{ lineHeight: 0 }}>
            <style>{`
                .calendly-inline-widget iframe {
                    border: none !important;
                    outline: none !important;
                    box-shadow: none !important;
                    display: block !important;
                }
            `}</style>
            <InlineWidget
                styles={{
                    minWidth: '320px',
                    height: '1300px',
                    border: 'none',
                    outline: 'none',
                }}
                pageSettings={{
                    hideEventTypeDetails: false,
                    hideLandingPageDetails: true,
                    hideGdprBanner: true,
                }}
                url={`https://calendly.com/${props.eventId}`}
            />
        </div>
    );
}